"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistButtonView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const StyledButton = (0, app_1.styled)(ui_1.Button) `
  position: absolute;
  border-left: 1px solid ${(theme) => theme.stroke};
  border-bottom: 1px solid ${(theme) => theme.stroke};
  background: transparent;
  color: ${(theme) => theme.stroke};
  top: 0;
  right: 0;
  width: 3.5rem;
  height: 3.5rem;
  ${(theme) => theme.flexCenter};
  z-index: 1;
  > svg {
    transition: all 0.2s;
    fill: ${(theme, { $active }) => ($active ? theme.colors.primary : 'white')};
    stroke: ${(theme, { $active }) => $active ? theme.colors.primary : 'currentcolor'};
  }
`;
function WishlistButtonView({ active, onClick, className, }) {
    return ((0, jsx_runtime_1.jsx)(StyledButton, Object.assign({ className: className, "aria-label": "Toggle wishlist", kind: ['icon'], "$active": active, onClick: onClick, "data-active": active }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgWishlist, {}) })));
}
exports.WishlistButtonView = WishlistButtonView;
